var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdminUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n    .st0{fill:none;stroke:#1356da;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 32,
    cy: 45.4,
    r: 14.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.6,53.6c2.7-4,7.2-6.7,12.4-6.7s9.8,2.7,12.4,6.7"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 32,
    cy: 41.3,
    r: 5.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45.8,31.6c0-7.6-6.2-13.8-13.8-13.8S18.2,24,18.2,31.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13,42.4c-0.9-1.6-1.6-3.2-2.1-5H4.1V25.8H11c0.5-1.7,1.2-3.4,2.1-5l-4.9-4.9l8.2-8.2l4.9,4.9         c1.5-0.9,3.2-1.6,5-2.1V3.7h11.6v6.9c1.8,0.5,3.5,1.2,5,2.1l4.9-4.9l8.2,8.2L51,20.8c0.9,1.5,1.6,3.2,2,5h6.9v11.6H53         c-0.5,1.8-1.2,3.5-2,5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminUser);
export default __webpack_public_path__ + "static/media/admin-user.0230b8d4b34d504d52b3ecb25965d3e7.svg";
export { ForwardRef as ReactComponent };